import { render } from "./pagination.md?vue&type=template&id=e575e612"
import script from "./pagination.md?vue&type=script&lang=js"
export * from "./pagination.md?vue&type=script&lang=js"
script.render = render

export default script